import type { Mission } from '../missions.ts'

export const ferc: Mission = {
  id: "ferc",
  name: "Federal Energy Regulatory Commission",
  short: "FERC",
  call: "Energy Markets",
  kind: "subagency",
  parent: "doe",
  url: "https://www.ferc.gov/",
  established: 1977,
  palette: {
    primary: "#00a886",
    secondary: "#0060a9",
    accent: "#a8996e",
  },
  colorSource: {
    kind: "seal",
    url: "https://commons.wikimedia.org/wiki/File:Seal_of_the_United_States_Federal_Energy_Regulatory_Commission.svg",
  },
  motif: "bolt",
  mission: {
    text: "Assist consumers in obtaining reliable, safe, secure, and economically efficient energy services at a reasonable cost through appropriate regulatory and market means, and collaborative efforts.",
    url: "https://www.ferc.gov/what-ferc",
  },
  fact: {
    text: "FERC was established in the Department of Energy effective October 1, 1977, succeeding the Federal Power Commission, which had operated since 1920.",
    url: "https://www.archives.gov/research/guide-fed-records/groups/138.html",
  },
  seal: {
    file: "public/seals/ferc.svg",
    source: "https://commons.wikimedia.org/wiki/File:Seal_of_the_United_States_Federal_Energy_Regulatory_Commission.svg",
  },
  identifier: {
    about: "https://www.ferc.gov/what-ferc",
    accessibility: "https://www.ferc.gov/ferc-accessibility-statement",
    foia: "https://www.ferc.gov/foia",
    noFear: "https://www.ferc.gov/enforcement-legal/legal/no-fear-act",
    oig: "https://www.energy.gov/ig/office-inspector-general",
    performance: "https://www.ferc.gov/strategic-documents",
    privacy: "https://www.ferc.gov/privacy",
  },
  media: {
    photos: [
      {
        file: "/media/ferc-sabine-pass-lng.jpg",
        small: "/media/ferc-sabine-pass-lng-sm.jpg",
        alt: "The Sabine Pass liquefied natural gas terminal, with process trains and flare stacks, seen across the water as a tug passes.",
        title: "Sabine Pass LNG Terminal, Cameron Parish, Louisiana, April 15, 2025",
        creator: "Quintin Soloviev",
        source: "https://commons.wikimedia.org/wiki/File:Cheniere_Sabine_Pass_LNG_Terminal.jpg",
        license: "CC BY 4.0",
      },
      {
        file: "/media/ferc-nrc-joint-meeting.jpg",
        small: "/media/ferc-nrc-joint-meeting-sm.jpg",
        alt: "Commissioners and staff of FERC and the Nuclear Regulatory Commission seated around a long curved table at FERC headquarters.",
        title: "Joint meeting of FERC and the NRC on grid reliability, FERC headquarters, Washington, D.C., June 7, 2018",
        creator: "Federal Energy Regulatory Commission, via the Nuclear Regulatory Commission",
        source: "https://commons.wikimedia.org/wiki/File:NRC_and_the_Federal_Energy_Regulatory_Commission_Joint_Meeting_(42724183492).jpg",
        license: "CC BY 2.0",
      },
    ],
  },
}
